(function(root) {
  'use strict';
  var sizes = typeof module !== 'undefined' && module.exports ? require('./size-engine.js') : root.IndiaLivingSizes;
  function identity(item) {
    var props = Object.keys(item.properties || {}).sort().map(function(k) { return [k, item.properties[k]]; });
    var raw = JSON.stringify([item.variant_id, props, item.selling_plan_allocation?.selling_plan?.id || '']);
    var a = 2166136261, b = 5381;
    for (var n = 0; n < raw.length; n++) { a = Math.imul(a ^ raw.charCodeAt(n), 16777619); b = Math.imul(b, 33) ^ raw.charCodeAt(n); }
    return String(item.variant_id) + '-' + (a >>> 0).toString(36) + '-' + (b >>> 0).toString(36);
  }
  function rugs(cart, bagId) {
    return cart.items.filter(function(i) {
      return Number(i.product_id) !== Number(bagId) && /rug|runner|carpet|dhurrie|durrie/i.test(i.product_type + ' ' + i.product_title);
    }).map(function(i) {
      var options = (i.options_with_values || []).filter(function(o) { return /size|dimension/i.test(o.name); });
      var size = sizes.parse(options.length ? options[0].value : i.variant_title);
      return { item:i, ref:identity(i), size:size, eligible:Number.isFinite(size.area) && size.area > 0 };
    }).filter(function(r) { return r.size.group !== 'Swatch'; });
  }
  function tier(area) { return [6,15,24,40,54,80,Infinity].findIndex(function(max) { return area <= max + 0.001; }); }
  function plan(cart, config, selection) {
    var rows = rugs(cart, config.productId), managed = cart.items.filter(function(i) { return Number(i.product_id) === Number(config.productId) && i.properties?._bag_for; });
    var all = (selection?.all !== undefined ? selection.all : cart.attributes?.['Cotton bags'] === 'All rugs');
    var desired = [];
    rows.forEach(function(r) {
      if (!r.eligible) return;
      var existing = managed.find(function(i) { return i.properties._bag_for === r.ref; });
      var choice = selection?.ref === r.ref ? selection.count : existing ? existing.properties._bag_mode === 'all' ? 'all' : existing.quantity : 0;
      var count = all || choice === 'all' ? r.item.quantity : Math.min(r.item.quantity, Math.max(0,Number(choice)||0));
      var variant = config.variants[tier(r.size.area)];
      if (!count || !variant?.available) return;
      desired.push({id:Number(variant.id), quantity:count, properties:{_bag_for:r.ref, _bag_mode:all || choice === 'all' ? 'all' : 'fixed', 'For rug':r.item.product_title, 'Rug size':r.item.variant_title || ''}});
    });
    var updates = {}, additions = [], used = new Set();
    desired.forEach(function(d) {
      var match = managed.find(function(i) { return !used.has(i.key) && Number(i.variant_id) === d.id && i.properties._bag_for === d.properties._bag_for && i.properties._bag_mode === d.properties._bag_mode; });
      if (match) { used.add(match.key); if(match.quantity !== d.quantity) updates[match.key] = d.quantity; }
      else additions.push(d);
    });
    managed.forEach(function(i) { if(!used.has(i.key)) updates[i.key] = 0; });
    return {rows:rows, desired:desired, updates:updates, additions:additions, all:all};
  }
  var api={identity:identity,rugs:rugs,tier:tier,plan:plan};
  if(typeof module !== 'undefined' && module.exports) module.exports=api; else root.IndiaLivingCartOptions=api;
})(typeof window !== 'undefined' ? window : this);
